"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roomTypeFromPlaceName = roomTypeFromPlaceName;
exports.canonicalRoomIndex = canonicalRoomIndex;
exports.compareCanonicalPlaces = compareCanonicalPlaces;
const place_stats_1 = require("./place-stats");
const ROOM_RULES = [
    { room: 'master_bath', pattern: /רחצה.{0,8}הורים|הורים.{0,8}(רחצה|אמבט|מקלחת)|מאסטר.{0,8}(אמבט|רחצה|מקלחת)|(אמבט|רחצה|מקלחת).{0,8}מאסטר/ },
    { room: 'master_bedroom', pattern: /חדר הורים|שינה ראשי|מאסטר|חדר שינה זוגי/ },
    { room: 'mamad', pattern: /ממ["״']?ד|ממד/ },
    { room: 'entrance', pattern: /כניסה|לובי/ },
    { room: 'kitchen_salon', pattern: /מטבח|סלון|פינת אוכל/ },
    { room: 'balcony', pattern: /מרפסת/ },
    { room: 'corridor', pattern: /מסדרון|פרוזדור/ },
    { room: 'bathroom', pattern: /אמבט|שירותים|רחצה|מקלחת/ },
    { room: 'bedroom', pattern: /חדר שינה|חדר ילדים/ },
];
function roomTypeFromPlaceName(name) {
    const text = String(name ?? '').trim();
    if (!text)
        return 'other';
    for (const rule of ROOM_RULES) {
        if (rule.pattern.test(text))
            return rule.room;
    }
    return 'other';
}
function canonicalRoomIndex(room) {
    const index = place_stats_1.CANONICAL_ROOM_ORDER.indexOf(room);
    return index === -1 ? place_stats_1.CANONICAL_ROOM_ORDER.length : index;
}
function compareCanonicalPlaces(left, right) {
    const roomDelta = canonicalRoomIndex(roomTypeFromPlaceName(left.name))
        - canonicalRoomIndex(roomTypeFromPlaceName(right.name));
    if (roomDelta !== 0)
        return roomDelta;
    return left.name.localeCompare(right.name, 'he');
}
